import { useFormContext } from "react-hook-form";
import { Checkbox } from "@shared/ui/checkbox/checkbox";
import { LEGAL_DOCUMENTS } from "@shared/const/legal-documents";
import s from "./consent-block.module.scss";

export const ConsentCaption = ({ className = "" }) => {
  return (
    <span className={`${s.caption} ${className}`.trim()}>
      Продолжая, вы подтверждаете, что ознакомились с{" "}
      <a target="_blank" rel="noreferrer" href={LEGAL_DOCUMENTS.userAgreement.url}>
        {LEGAL_DOCUMENTS.userAgreement.labelForCaption}
      </a>
      .
    </span>
  );
};

export const ConsentBlock = ({
  className = "",
  showPublicationConsent = false,
  requiredName = "personal_data_consent",
  publicationName = "publication_consent",
  showUserAgreementCaption = true,
}) => {
  const { formState } = useFormContext();

  return (
    <div className={`${s.wrapper} ${className}`.trim()}>
      <div className={s.checkboxes}>
        <Checkbox
          name={requiredName}
          compact
          className={s.checkbox}
          validation={{
            required: "Необходимо дать согласие на обработку персональных данных.",
          }}
          label={
            <span className={s.text}>
              Я даю <a target="_blank" rel="noreferrer" href={LEGAL_DOCUMENTS.consent.url}>
                {LEGAL_DOCUMENTS.consent.labelForForm}
              </a>{" "}
              в соответствии с{" "}
              <a target="_blank" rel="noreferrer" href={LEGAL_DOCUMENTS.policy.url}>
                {LEGAL_DOCUMENTS.policy.labelForForm}
              </a>
            </span>
          }
        />
        {showPublicationConsent ? (
          <Checkbox
            name={publicationName}
            compact
            className={s.checkbox}
            label={
              <span className={s.text}>
                <a target="_blank" rel="noreferrer" href={LEGAL_DOCUMENTS.consentPublication.url}>
                  {LEGAL_DOCUMENTS.consentPublication.labelForForm}
                </a>
              </span>
            }
          />
        ) : null}
      </div>
      {formState?.errors?.[requiredName]?.message ? (
        <span className={s.error}>
          {formState.errors[requiredName].message}
        </span>
      ) : null}
      {showUserAgreementCaption ? <ConsentCaption /> : null}
    </div>
  );
};
